import { render, staticRenderFns } from "./UserInfoWithIcon.vue?vue&type=template&id=f50565f2&scoped=true&"
import script from "./UserInfoWithIcon.vue?vue&type=script&lang=ts&"
export * from "./UserInfoWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfoWithIcon.vue?vue&type=style&index=0&id=f50565f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50565f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
